import React, { useState } from "react";

const MAX_FILE_SIZE = 100 * 1024; // 100KB
const REQUIRED_WIDTH = 32;
const REQUIRED_HEIGHT = 32;
const ImageUpload: React.FC = () => {
  const [previewUrl, setPreviewUrl] = useState<string | null>(null);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  const handleFileChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ): void => {
    const file = event.target.files?.[0];

    if (!file) {
      return;
    }

    const isImage = file.type.startsWith("image/");
    const isTooLarge = file.size > MAX_FILE_SIZE * 1024 * 1024;

    if (!isImage) {
      setErrorMessage("Only image files are allowed.");
      setPreviewUrl(null);
      return;
    }

    if (isTooLarge) {
      setErrorMessage(`Image must be less than ${MAX_FILE_SIZE} MB.`);
      setPreviewUrl(null);
      return;
    }

    setErrorMessage(null);
    setPreviewUrl(URL.createObjectURL(file));
  };

  return (
    <div className="col-6">
      <div className="row">
        <label htmlFor="fileInput">
          Upload an image (Max {MAX_FILE_SIZE}KB):
        </label>
        <input
          type="file"
          id="fileInput"
          accept="image/*"
          onChange={handleFileChange}
        />

        {errorMessage && <p style={{ color: "red" }}>{errorMessage}</p>}
      </div>
      <div>
        {previewUrl && (
          <div
          className=""
            style={{
              marginTop: "10px",
              border: "1px solid grey",
              padding: "10px",
            }}
          >
            <img
              src={previewUrl}
              alt="Image Preview"
              style={{ maxWidth: "200px", borderRadius: "8px" }}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default ImageUpload;
